import React from "react";
import Grid from '@material-ui/core/Grid';
import usernameBorder from "../../../assets/images/username_edt.png";
import blueButton from "../../../assets/images/btn_blue_radius_setting.png";
import startButton from "../../../assets/images/ic_start_btn.png";


class LoginButton extends React.Component{
    constructor(props) {
        super(props);

    }
    componentDidMount() {
    }

    render() {
        const {text}=this.props.data
        return(
            <Grid
                // className='button'
                container
                alignItems={"center"}
                justify={"center"}
                style={{
                    backgroundImage: "url(" + blueButton + ")",
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    // maxHeight:'125px'
                }}
                className='clickable'
            >
                 <p style={{
                     color:'#ffffff',
                     fontSize:'1.3vh'
                 }}>
                     {text}
                </p>
            </Grid>
        )
    }
}
export default LoginButton